module.exports = __webpack_public_path__ + "img/screenshot_android_nimmerso.6e7e0204.png";